import React from "react";
import styled from "styled-components";
import { Link, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { FiLogOut } from "react-icons/fi";
import { LucideBox, LucideList, LucideMessageSquare } from "lucide-react";

const LayoutWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;
const Sidebar = styled.nav`
  width: 240px;
  background: #222;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  @media (max-width: 700px) {
    width: 64px;
    padding: 1rem 0.5rem;
  }
`;
const SidebarLink = styled(Link)<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: ${(p) => (p.active ? "#e97d7d" : "#fff")};
  background: ${(p) => (p.active ? "#fff2f2" : "transparent")};
  padding: 0.8rem 1rem;
  border-radius: 0.7rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #e97d7d22;
    color: #e97d7d;
  }
  @media (max-width: 700px) {
    justify-content: center;
    gap: 0.3rem;
    padding: 0.8rem 0.2rem;
    font-size: 1.2rem;
  }
`;
const Main = styled.main`
  flex: 1;
  background: #f8f8f8;
  min-height: 100vh;
  padding: 2rem 2.5rem;
  @media (max-width: 700px) {
    padding: 1rem 0.5rem;
  }
`;
const Topbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1.2rem 2rem;
  border-bottom: 1.5px solid #f0eaea;
  margin-bottom: 2rem;
  border-radius: 0.7rem;
`;
const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #e97d7d;
`;
const LogoutBtn = styled.button`
  background: #e97d7d;
  color: #fff;
  border: none;
  border-radius: 2rem;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.7rem 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  transition: background 0.2s;
  &:hover {
    background: #d96a6a;
  }
`;

const AdminLayout: React.FC = () => {
  const { signOut } = useAuth();
  return (
    <LayoutWrapper>
      <Sidebar>
        <SidebarLink to="/admin/products">
          <LucideBox size={20} /> Products
        </SidebarLink>
        <SidebarLink to="/admin/orders">
          <LucideList size={20} /> Orders
        </SidebarLink>
        <SidebarLink to="/admin/messages">
          <LucideMessageSquare size={20} /> Messages
        </SidebarLink>
      </Sidebar>
      <Main>
        <Topbar>
          <Title>Admin Dashboard</Title>
          <LogoutBtn onClick={signOut}>
            <span
              style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
            >
              {FiLogOut({ size: 18 })} Logout
            </span>
          </LogoutBtn>
        </Topbar>
        <Outlet />
      </Main>
    </LayoutWrapper>
  );
};
export default AdminLayout;
